import { render, staticRenderFns } from "./OngoingRequestsCRM.vue?vue&type=template&id=47c6f84f&scoped=true"
import script from "./OngoingRequestsCRM.vue?vue&type=script&lang=js"
export * from "./OngoingRequestsCRM.vue?vue&type=script&lang=js"
import style0 from "./ongoing-requests-crm.scss?vue&type=style&index=0&id=47c6f84f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c6f84f",
  null
  
)

export default component.exports